import { ProductCard } from "../common/product-card";

export default function ProductList({ products }: any) {
  return (
    <div className="shop-pro-content">
      <div className="shop-pro-inner">
        <div className="row">
          {products.map((product: any, index: any) => (
            <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 ec-product-content">
              <ProductCard isSample={false} key={product.id} {...product} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
